import { ChannelId } from 'services/order/order.type';

export enum ConsumptionModeType {
    MODE_SIT_IN = 'MODE_SIT_IN',
}

export interface ConsumptionMode {
    consumptionModeId: number;
    restaurantId: number;
    brandId: number;
    channelId: ChannelId;
    delay: number;
    paymentMethods: PaymentMethod[];
    type: ConsumptionModeType;
}

export interface PaymentMethod {
    paymentMethodId: number;
    brandId: number;
    channelId: ChannelId;
    restaurantId: number;
    posDeviceId: number | null;
    code: PaymentMethodCode;
    active: boolean;
}

export enum PaymentMethodCode {
    EWallet = 'EWallet',
    Stripe = 'Stripe',
}
